import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import { LastCartsSelector } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastCartsSelector/LastCartsSelector';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { StoredCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/StoredCart';

interface LastVehiclesSelectorProps {
  onUpdated: (cartItem: AutomobileFormItem) => void;
  updateAutomobileData: (cartItem: AutomobileFormItem) => Promise<void>;
}

export const LastVehiclesSelector = ({ onUpdated, updateAutomobileData }: LastVehiclesSelectorProps) => {
  const { createNewCartFromStoredCart } = useCart();

  const onSelectedVehicle = async (option: StoredCart) => {
    const newCart = createNewCartFromStoredCart(option);

    if (!newCart) return;

    const cartItem = newCart.items.map((item) => item.toFormItem())[0] as AutomobileFormItem;

    onUpdated(cartItem);

    await updateAutomobileData(cartItem);
  };

  return <LastCartsSelector titleId={'LAST_VEHICLES'} startIcon={'directions_car'} onSelected={onSelectedVehicle} />;
};
